import { render, staticRenderFns } from "./formFiltroDocumentos.vue?vue&type=template&id=227ef8bf&scoped=true"
import script from "./formFiltroDocumentos.vue?vue&type=script&lang=js"
export * from "./formFiltroDocumentos.vue?vue&type=script&lang=js"
import style0 from "./formFiltroDocumentos.vue?vue&type=style&index=0&id=227ef8bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ef8bf",
  null
  
)

export default component.exports